// extracted by mini-css-extract-plugin
export default {"root":"AttachmentContainer_root__Ec7yh"};